<template>
  <div class="campaign-performance">
    <div class="py-4">
      <div class="row">
        <div class="col-md-3">
          <div class="card p-3">
            <h6 class="text-muted text-center text-uppercase">Impressions</h6>
            <h2 class="fw-bold text-center">24,510</h2>
          </div>
        </div>

        <div class="col-md-3">
          <div class="card p-3">
            <h6 class="text-muted text-center text-uppercase">
              Engagement Rate
            </h6>
            <h2 class="fw-bold text-center">17,300</h2>
          </div>
        </div>

        <div class="col-md-3">
          <div class="card p-3">
            <h6 class="text-muted text-center text-uppercase">
              Clicks to Landing Page
            </h6>
            <h2 class="fw-bold text-center">14,500</h2>
          </div>
        </div>

        <div class="col-md-3">
          <div class="card p-3">
            <h6 class="text-muted text-center text-uppercase">
              Applications from Social Media
            </h6>
            <h2 class="fw-bold text-center">12,700</h2>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="card p-3">
            <h6 class="text-muted mb-2 text-uppercase">
              engagement by platform
            </h6>
            <div>
              <StackedBarApex />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card p-3">
            <h6 class="text-muted mb-2 text-uppercase">Clicks over time</h6>
            <div>
              <LineApex />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <CCard>
        <CCardHeader>
          <h5 class="text-primary d-block">Applied Candidates by Country</h5>
        </CCardHeader>
        <CCardBody>
          <div
            class="d-flex justify-content-center align-items-center"
            style="width: 100%; height: 500px"
          >
            <!-- <GeoChart
            v-if="getCandidateByCountry.length > 0"
            :candidates="getCandidateByCountry"
          /> -->
            <iframe
              src="/map/socialMedia.html"
              width="1366"
              height="550"
              style="border: 0"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </CCardBody>
      </CCard>
    </div>
  </div>
</template>
<script>
import BasicBar from "@/components/reusable/Charts/BasicBar.vue";
import HeatMap from "@/components/reusable/Charts/Apex/HeatMap.vue";
import StackedBarApex from "@/components/reusable/Charts/Apex/StackedBarApex.vue";
import LineApex from "@/components/reusable/Charts/Apex/LineApex.vue";

export default {
  name: "Emails",
  components: {
    BasicBar,
    HeatMap,
    StackedBarApex,
    LineApex,
  },
  data() {
    return {
      openAndClickRatesData: [
        {
          name: "Open Rate",
          borderColor: "#5478AF",
          backgroundColor: "#5478AF",
          values: [
            { name: "Campaign 1", value: 100 },
            { name: "Campaign 2", value: 200 },
            { name: "Campaign 3", value: 350 },
            { name: "Campaign 4", value: 500 },
            { name: "Campaign 5", value: 650 },
            { name: "Campaign 6", value: 800 },
          ],
        },
        {
          name: "Click Rate",
          borderColor: "#25436D",
          backgroundColor: "#25436D",
          values: [
            { name: "Campaign 1", value: 200 },
            { name: "Campaign 2", value: 100 },
            { name: "Campaign 3", value: 320 },
            { name: "Campaign 4", value: 450 },
            { name: "Campaign 5", value: 500 },
            { name: "Campaign 6", value: 650 },
          ],
        },
      ],
      funnelChartData: [
        {
          name: "Total Reach",
          value: 500,
        },
        {
          name: "Total Clicks",
          value: 400,
        },
        {
          name: "Total Applications Started",
          value: 350,
        },
        {
          name: "Total Applications Completed",
          value: 250,
        },
      ],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        animation: {
          duration: 0,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                display: true,
                beginAtZero: true,
                fontStyle: "bold",
              },
              scaleLabel: {
                display: false,
                fontStyle: "bold",
              },
              gridLines: {
                display: true,
              },
              title: {
                display: false,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                display: true,
                beginAtZero: true,
                fontStyle: "bold",
              },
              scaleLabel: {
                display: true,
                fontStyle: "bold",
              },
              gridLines: {
                display: true,
              },
              title: {
                display: false,
              },
            },
          ],
        },
        plugins: {
          datalabels: {
            color: "#fff",
            anchor: "end",
            align: "start",
            font: {
              weight: "bold",
              size: 12,
            },
            formatter: (value) => value,
          },
        },
      },
      campaignContributionData: [
        {
          name: "Total Reach",
          value: 500,
          backgroundColor: "#4971AB",
        },
        {
          name: "Total Clicks",
          value: 400,
          backgroundColor: "#25436D",
        },
      ],
      pieOptions: {
        maintainAspectRatio: false,
        animation: {
          duration: 0, // Disable all animations
        },
        legend: {
          display: false,
        },
      },
      defaultDatasets: [
        {
          backgroundColor: ["#25436D", "#4971AB"],
          data: [500, 400],
          label: "Total Reach",
          hoverOffset: 10,
        },
      ],
      labels: ["Total Reach", "Total Clicks"],
    };
  },
};
</script>
<style scoped>
.card {
  border: none;
  border-radius: 15px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.funnel {
  background: linear-gradient(to bottom, #1e3a8a, #2563eb);
  border-radius: 16px;
  color: #ffffff;
  text-align: center;
  padding: 2rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  height: 100%;
  min-height: 400px;
}

.funnel-step {
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.divider {
  width: 100%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.4);
  margin: 0.5rem 0;
}
.chart-container {
  height: 200px;
}
.donut-chart {
  height: 250px;
}
</style>
